import { render, staticRenderFns } from "./content-upload.vue?vue&type=template&id=064ad841&"
import script from "./content-upload.vue?vue&type=script&lang=js&"
export * from "./content-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-upload.vue"
export default component.exports